import { ActionValoration } from '@app/enums/valoration.enums';
import { Overview } from '@app/interface/assessment';
import { AssessmentOverviewRequest, LastValorationRequest } from '@app/interface/ngrxInterfaces/assessment.state';
import {
  PragmaPowerCategory,
  PragmaPowerCategoriesRequest,
} from '@app/interface/pragma-power-categories.interface';
import {
  PragmaPowerDefinition,
  PragmaPowerDefinitionRequest,
} from '@app/interface/pragma-power-definition.interface';
import {
  PragmaPowerScores,
  PragmaPowerScoresRequest,
} from '@app/interface/pragma-power-scores-interface';
import { DataValorationAssessment, Valoration } from '@app/interface/valoration-last-assessment.interface';
import { createAction, props } from '@ngrx/store';

export const loadPragmaPowerCategories = createAction(
  ActionValoration.LOAD_PRAGMAPOWERS_CATEGORIES,
  props<{ pragmaPowerRequest: PragmaPowerCategoriesRequest }>()
);

export const loadPragmaPowerCategoriesSuccess = createAction(
  ActionValoration.LOAD_PRAGMAPOWERS_CATEGORIES_SUCCESSFULLY,
  props<{ pragmaPowerCategories: PragmaPowerCategory[] }>()
);

export const loadPragmaPowerDefinition = createAction(
  ActionValoration.LOAD_PRAGMAPOWER_DEFINITION,
  props<{ pragmaPowerDefinitionRequest: PragmaPowerDefinitionRequest }>()
);

export const loadPragmaPowerDefinitionSuccess = createAction(
  ActionValoration.LOAD_PRAGMAPOWER_DEFINITION_SUCCESSFULLY,
  props<{ pragmaPowerDefinition: PragmaPowerDefinition[] }>()
);

export const loadPragmaPowerScores = createAction(
  ActionValoration.LOAD_PRAGMAPOWER_SCORES,
  props<{ pragmaPowerScoresRequest: PragmaPowerScoresRequest }>()
);

export const loadPragmaPowerScoresSuccess = createAction(
  ActionValoration.LOAD_PRAGMAPOWER_SCORES_SUCCESSFULLY,
  props<{ pragmaPowerScores: PragmaPowerScores[] }>()
);
export const loadCurrentValoration = createAction(
  ActionValoration.LOAD_CURRENT_VALORATION,
  props<{ currentValoration: Valoration }>()
)
export const loadLastValoration = createAction(
  ActionValoration.LOAD_LAST_VALORATION,
  props<{ lastValorationRequest: LastValorationRequest }>()
);

export const loadLastValorationSuccess = createAction(
  ActionValoration.LOAD_LAST_VALORATION_SUCCESSFULLY,
  props<{ lastValoration: Valoration | undefined }>()
);

export const loadApprovedAssessment = createAction(
  ActionValoration.LOAD_APPROVED_ASSESSMENT,
  props<{ approvedAssessmentRequest: AssessmentOverviewRequest }>()
);

export const loadApprovedAssessmentSuccess = createAction(
  ActionValoration.LOAD_APPROVED_ASSESSMENT_SUCCESSFULLY,
  props<{ approvedAssessment: Overview | null }>()
);

export const loadRejectedAssessment = createAction(
  ActionValoration.LOAD_REJECTED_ASSESSMENT,
  props<{ rejectedAssessmentRequest: AssessmentOverviewRequest }>()
);

export const loadRejectedAssessmentSuccess = createAction(
  ActionValoration.LOAD_REJECTED_ASSESSMENT_SUCCESSFULLY,
  props<{ rejectedAssessment: Overview | null }>()
);

export const loadPendingAssessment = createAction(
  ActionValoration.LOAD_PENDING_ASSESSMENT,
  props<{ pendingAssessmentRequest: AssessmentOverviewRequest }>()
);

export const loadPendingAssessmentSuccess = createAction(
  ActionValoration.LOAD_PENDING_ASSESSMENT_SUCCESSFULLY,
  props<{ pendingAssessment: Overview | null }>()
);

export const loadStartedAssessment = createAction(
  ActionValoration.LOAD_STARTED_ASSESSMENT,
  props<{ startedAssessmentRequest: AssessmentOverviewRequest }>()
);

export const loadStartedAssessmentSuccess = createAction(
  ActionValoration.LOAD_STARTED_ASSESSMENT_SUCCESSFULLY,
  props<{ startedAssessment: Overview | null }>()
);

export const loadFinalizedAutoassessment = createAction(
  ActionValoration.LOAD_FINALIZED_AUTOASSESSMENT,
  props<{ finalizedAutoassessmentRequest: AssessmentOverviewRequest }>()
);

export const loadFinalizedAutoassessmentSuccess = createAction(
  ActionValoration.LOAD_PENDING_ASSESSMENT_SUCCESSFULLY,
  props<{ finalizedAutoassessment: Overview | null }>()
);

export const loadStartedAutoassessment = createAction(
  ActionValoration.LOAD_STARTED_AUTOASSESSMENT,
  props<{ startedAutoassessmentRequest: AssessmentOverviewRequest }>()
);

export const loadStartedAutoassessmentSuccess = createAction(
  ActionValoration.LOAD_STARTED_AUTOASSESSMENT_SUCCESSFULLY,
  props<{ startedAutoassessment: Overview | null }>()
);

export const setSeniorityCurrentValoration = createAction(
  ActionValoration.SET_SENIORITY_CURRENT_VALORATION,
  props<{ seniority: DataValorationAssessment }>()
);

export const saveAssessmentSummary = createAction(
  ActionValoration.SAVE_ASSESSMENT_SUMMARY,
  props<{
    isTeamValued: boolean;
    isTechnicalValued: boolean;
    canSeniorityUp: boolean;
    previousAssessmentScore: number;
    isLowerLastAssessmentScore: boolean;
  }>()
);

export const resetFinalizedAssessment = createAction(
  ActionValoration.RESET_FINALIZED_ASSESSMENT
);
export const resetApprovedAssessment = createAction(
  ActionValoration.RESET_APPROVED_ASSESSMENT
);
export const resetRejectedAssessment = createAction(
  ActionValoration.RESET_REJECTED_ASSESSMENT
);
export const resetStartedAssessment = createAction(
  ActionValoration.RESET_STARTED_ASSESSMENT
);
export const resetPendingAssessment = createAction(
  ActionValoration.RESET_PENDING_ASSESSMENT
);
export const resetFinalizedAutoassessment = createAction(
  ActionValoration.RESET_FINALIZED_AUTOASSESSMENT
);
export const resetStartedAutoassessment = createAction(
  ActionValoration.RESET_STARTED_AUTOASSESSMENT
);

export const resetValorationState = createAction(
  ActionValoration.RESET_VALORATION_STATE
);
